<template>
<div class="">
  <Breadcrumb>
    <BreadcrumbItem to="/dashboard">
      <Icon type="ios-home" /> 首页
    </BreadcrumbItem>
    <BreadcrumbItem v-if="study">
      <strong @click="showStudys">
        {{ study.abbreviation }} <Icon type="ios-arrow-down"></Icon>
      </strong>
    </BreadcrumbItem>
    <BreadcrumbItem :to="{ name: item.name, params: item.params }"
     v-for="(item, key) in items" :key="key">
     {{ item.title }}
    </BreadcrumbItem>
  </Breadcrumb>
  <Modal v-model="showChange" :footer-hide="true" title="切换研究" width="72">
    <select-study ref="selectStudy" @closeModal="showChange = false"></select-study>
  </Modal>
</div>
</template>

<script>
import { ViewStudy } from '@/api/study'
import SelectStudy from '@/components/layout/SelectStudy'

export default {
  name: 'breadcrumb',
  data: function () {
    return {
      study: null,
      showChange: false,
      items: []
    }
  },
  mounted: function () {
    this.getTitle()
  },
  components: {
    'select-study': SelectStudy
  },
  watch: {
    $route: function (to, from) {
      this.getTitle()
    }
  },
  methods: {
    getStudy: function () {
      const id = this.$route.params.id
      if (id) {
        ViewStudy(id).then(async res => {
          this.study = res
        })
      } else {
        this.study = null
      }
    },
    getTitle: function () {
      this.items = []
      var matches = this.$route.matched
      this.getStudy()
      for (var i = 1; i < matches.length; i++) {
        var item = {
          title: matches[i].meta ? matches[i].meta.title : null,
          name: matches[i].name,
          params: this.$route.params
        }
        if (item.title) {
          this.items.push(item)
        }
      }
    },
    showStudys: function () {
      this.$refs.selectStudy.fetchData()
      this.showChange = true
    }
  }
}
</script>
